<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type { BlogT } from '~/schema/types'
const props = defineProps<{
  blog: BlogT
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <UiCard
    :key="blog.slug"
    :class="
      cn(
        'relative p-0 shadow-none border flex flex-col overflow-hidden hover:shadow-lg hover:bg-surface-container-high transition-all transform border-outline-variant',
        props.class
      )
    "
  >
    <NuxtImg
      v-if="blog.image"
      :src="blog.image"
      class="object-content w-full img aspect-video"
      :alt="blog.image_alt ?? undefined"
      loading="lazy"
    />
    <div class="flex flex-col justify-between grow p-3.5">
      <h2
        class="font-display font-bold group-hover:text-primary line-clamp-2 mb-2 title"
      >
        {{ blog.title }}
      </h2>
      <div class="w-full flex left-0 right-0">
        <div
          class="flex flex-wrap items-center gap-x-1 text-xs text-on-surface-variant"
        >
          <span class="author">
            {{ blog?.user?.name ?? '-' }}
          </span>
          <span>•</span>
          <span>
            {{ formatDateShortMonth(blog.published_at) }}
          </span>
          <template v-if="blog.category?.name">
            <span>•</span>
            <span class="text-primary category">
              {{ blog.category?.name }}
            </span>
          </template>
        </div>
      </div>
    </div>
    <NuxtLink
      prefetch
      :to="`/blog/${blog.slug}`"
      :aria-label="blog.title ?? 'Blog Title'"
      class="absolute inset-0 z-10"
    />
  </UiCard>
</template>
